import { Link } from 'react-router-dom';
import { resourceCards } from '@/mocks/siteData';

export default function ResourceCards() {
  return (
    <section className="py-14 md:py-20 bg-background-100" id="resources">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
              Featured Basetao Resources
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
              Explore our in-depth guides and resources to master your Basetao shopping experience.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {resourceCards.map((card) => (
              <Link
                key={card.slug}
                to={`/article/${card.slug}`}
                className="group block rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-200 overflow-hidden cursor-pointer"
              >
                <div className="w-full h-44 md:h-48 overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 group-hover:bg-accent-500 group-hover:text-white transition-colors duration-200">
                      <i className={`${card.icon} text-lg`}></i>
                    </div>
                    <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                      {card.title}
                    </h3>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    {card.description}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 whitespace-nowrap">
                    Read More
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}